/** Paginacao e quebra de celula das tabelas do painel de Analytics. */

export const PAGE_SIZES = [10, 25, 50, 100] as const;
export const DEFAULT_PAGE_SIZE = 25;

/** Total de paginas; sempre ao menos uma, mesmo sem linhas. */
export function pageCount(total: number, size: number): number {
    return Math.max(1, Math.ceil(total / Math.max(1, size)));
}

/** Mantem a pagina (base 1) dentro do intervalo valido, por exemplo apos um filtro reduzir as linhas. */
export function clampPage(page: number, total: number, size: number): number {
    return Math.min(Math.max(1, page), pageCount(total, size));
}

/** Linhas da pagina pedida (base 1). */
export function pageSlice<T>(rows: T[], page: number, size: number): T[] {
    const p = clampPage(page, rows.length, size);
    return rows.slice((p - 1) * size, p * size);
}

/** Texto comprido sem espaco (ID, e-mail) precisa quebrar em qualquer ponto para a coluna caber na tela. */
const LONG_TOKEN = /^\S{20,}$/;

export function isLongToken(text: string): boolean {
    return LONG_TOKEN.test(text);
}
